import apiClient from "../../client/apiClient"

export type BoardDoc = { _id: string; name: string; code: string; description?: string; isActive?: boolean }

export type BranchDoc = {
  _id: string
  name: string
  code?: string
  campusNo: string
  schoolName?: string
  schoolCode?: string
  address?: string
  contactNumber?: string
  email?: string
  principalName?: string
  headerText?: string
  logoKey?: string
  logoUrl?: string | null
  blackLogoKey?: string
  blackLogoUrl?: string | null
  strokeLogoKey?: string
  strokeLogoUrl?: string | null
  headerImageKey?: string
  headerImageUrl?: string | null
  boards?: (string | BoardDoc)[]
  isActive?: boolean
  studentAttendanceDefault?: "present" | "absent"
  studentAttendanceDefaultPending?: "present" | "absent" | null
  studentAttendanceDefaultEffectiveFrom?: string | null
  staffAttendanceDefault?: "present" | "absent"
  staffAttendanceDefaultPending?: "present" | "absent" | null
  staffAttendanceDefaultEffectiveFrom?: string | null
}

const BASE = "/owner/branches"

export const listBoards = async (): Promise<BoardDoc[]> => {
  const res = await apiClient({ method: "GET", url: "/owner/boards" })
  return res.data
}
export const createBoard = async (data: Partial<BoardDoc>): Promise<BoardDoc> =>
  (await apiClient({ method: "POST", url: "/owner/boards", data })).data
export const updateBoard = async (id: string, data: Partial<BoardDoc>): Promise<BoardDoc> =>
  (await apiClient({ method: "PUT", url: `/owner/boards/${id}`, data })).data
export const deleteBoard = async (id: string) =>
  (await apiClient({ method: "DELETE", url: `/owner/boards/${id}` })).data

// Upload a campus logo → { key, url }. Store the key on the campus.
export const uploadCampusLogo = async (
  file: File,
  type: "main" | "black" | "stroke" | "header" = "main"
): Promise<{ key: string; url: string }> => {
  const form = new FormData()
  form.append("logo", file)
  form.append("type", type)
  // axios sets the multipart Content-Type (with boundary) automatically for FormData.
  const res = await apiClient({ method: "POST", url: `${BASE}/upload-logo`, data: form })
  return res.data
}

export const listBranches = async (): Promise<BranchDoc[]> => {
  const res = await apiClient({ method: "GET", url: BASE })
  return res.data
}

export const createBranch = async (data: Partial<BranchDoc>): Promise<BranchDoc> => {
  const res = await apiClient({ method: "POST", url: BASE, data })
  return res.data
}

export const updateBranch = async (id: string, data: Partial<BranchDoc>): Promise<BranchDoc> => {
  const res = await apiClient({ method: "PUT", url: `${BASE}/${id}`, data })
  return res.data
}

export const deactivateBranch = async (id: string): Promise<BranchDoc> => {
  const res = await apiClient({ method: "PATCH", url: `${BASE}/${id}/deactivate` })
  return res.data
}

// Schedules the campus's default attendance status (student and/or staff).
// Takes effect from the start of the next day — never applies immediately —
// so it never overrides attendance already recorded, or being recorded, today.
export const updateAttendanceDefaults = async (
  id: string,
  data: { studentDefault?: "present" | "absent"; staffDefault?: "present" | "absent" }
): Promise<BranchDoc> => {
  const res = await apiClient({ method: "PUT", url: `${BASE}/${id}/attendance-defaults`, data })
  return res.data
}
